import { Ref, ref } from "vue";
import { getIncidents } from "../../infrastructure/apiServices/masterData.service";
import Incidence from "../../domain/interfaces/Incidence";
import { IncidencesTypes } from "../../domain/enum/IncidencesTypes";

export const useIncidences = () => {
    const incidence: Ref<Incidence> = ref({} as Incidence);
    const showNotificationIncidence: Ref<boolean> = ref<boolean>(false);
    
    const closeIncidence = () => { 
        showNotificationIncidence.value = false
    };
    loadIncidences(incidence, showNotificationIncidence);


    return { incidence, showNotificationIncidence, IncidencesTypes, closeIncidence };
};

const askForIncidences = async (showNotificationIncidence: Ref<boolean>): Promise<Incidence> => {
    const incidences = await getIncidents();
    if (!incidences.length) return {} as Incidence;

    const i = incidences[0];
    showNotificationIncidence.value = true;
    return {
        id: i.id,
        title: i.title,
        description: i.description,
        type: i.type as IncidencesTypes.Error | IncidencesTypes.Warning,
    };
}

const loadIncidences = async (incidence: Ref<Incidence>, showNotificationIncidence: Ref<boolean>) => {
    try {
        incidence.value = await askForIncidences(showNotificationIncidence);
    } catch (error) {
        console.error(error);
    }
};
